import shortid from 'shortid';
import parseImage from 'parsers/common/parseImage';
import getCategoryLabel from 'utils/getCategoryLabel';
import { getAttributeLabel, parameterToCategory } from 'utils/productParameters';
function getParameters(parametersKeys, data, i18n, productLabels) {
    return parametersKeys.reduce((parameters, key) => {
        const hasParameter = data === null || data === void 0 ? void 0 : data.category[parameterToCategory[key]];
        if (hasParameter && data) {
            if (!data[key])
                return [
                    ...parameters,
                    {
                        id: shortid(),
                        type: key,
                        title: getAttributeLabel(i18n, productLabels, key, data === null || data === void 0 ? void 0 : data.category.type),
                        name: '-',
                    },
                ];
            const { id: parameterId, name } = data[key];
            if (name && name !== 'static') {
                return [
                    ...parameters,
                    {
                        id: parameterId,
                        type: key,
                        title: getAttributeLabel(i18n, productLabels, key, data === null || data === void 0 ? void 0 : data.category.type),
                        name,
                    },
                ];
            }
            return [
                ...parameters,
                {
                    id: parameterId,
                    type: key,
                    title: getAttributeLabel(i18n, productLabels, key, data === null || data === void 0 ? void 0 : data.category.type),
                    name: '-',
                },
            ];
        }
        return parameters;
    }, []);
}
function getSupplier(data) {
    const supplier = data === null || data === void 0 ? void 0 : data.supplier;
    return Object.assign({}, supplier);
}
export function parseProduct(data, i18n, productLabels) {
    var _a, _b, _c, _d;
    const parametersKeys = [
        'width',
        'componentSize',
        'composition',
        'zipperType',
        'grammage',
        'upperSliderType',
        'underSliderType',
        'producerCode',
        'yardage',
    ];
    return Object.assign(Object.assign({}, data), { pictures: ((_b = (_a = data === null || data === void 0 ? void 0 : data.pictures) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b.map(({ node }) => (Object.assign(Object.assign({}, node), { picture: parseImage(node === null || node === void 0 ? void 0 : node.image) })))) ||
            ((_c = data === null || data === void 0 ? void 0 : data.pictures) === null || _c === void 0 ? void 0 : _c.map(({ picture }) => picture)) ||
            [], isActive: (data === null || data === void 0 ? void 0 : data.status) === 'ACTIVE', name: (data === null || data === void 0 ? void 0 : data.name) || '-', categoryId: ((_d = data === null || data === void 0 ? void 0 : data.category) === null || _d === void 0 ? void 0 : _d.id) || '', supplier: getSupplier(data), parameters: getParameters(parametersKeys, data, i18n, productLabels) });
}
export function parseProductCard(data, i18n) {
    var _a, _b, _c, _d, _e;
    const image = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.pictures) === null || _a === void 0 ? void 0 : _a.edges[0]) === null || _b === void 0 ? void 0 : _b.node) === null || _c === void 0 ? void 0 : _c.image;
    return Object.assign(Object.assign({}, data), { name: (data === null || data === void 0 ? void 0 : data.name) || '-', picture: parseImage(image), isActive: (data === null || data === void 0 ? void 0 : data.status) === 'ACTIVE', supplier: getSupplier(data), category: getCategoryLabel(data === null || data === void 0 ? void 0 : data.category, i18n), categoryId: ((_d = data === null || data === void 0 ? void 0 : data.category) === null || _d === void 0 ? void 0 : _d.id) || '', producerCode: ((_e = data === null || data === void 0 ? void 0 : data.producerCode) === null || _e === void 0 ? void 0 : _e.name) || '-' });
}
export function parseProductVariant(data) {
    const currentPrice = data === null || data === void 0 ? void 0 : data.currentPrice;
    const price = (currentPrice === null || currentPrice === void 0 ? void 0 : currentPrice.price) || '-';
    const currency = currentPrice === null || currentPrice === void 0 ? void 0 : currentPrice.currency;
    return Object.assign(Object.assign({}, data), { currentPrice: Object.assign(Object.assign({}, currentPrice), { priceName: currentPrice ? `${price} ${currency === null || currency === void 0 ? void 0 : currency.isoCode}` : '-' }) });
}
